import { CardList } from "../../Data/featureData";
import {
    setActivePipeline,
    updatePipelineIndex,
    clearActivePipeline
} from "./pipelineState";

export const addCardToBoard = (id, board, setBoard, updateDisabledCards) => {
    const cardList = CardList.filter((card) => id === card.id);
    if (cardList.length > 0) {
        setBoard((board) => [...board, cardList[0]]);
        updateDisabledCards(id);
    }
};

export const updateDisabledCards = (addedId, setDisabledCards) => {
    const addedCard = CardList.find(card => card.id === addedId);
    if (!addedCard) return;
    const newDisabledCards = CardList
        .filter(card => !addedCard.dependencies.includes(card.id) && card.id !== addedId)
        .map(card => card.id)
        .concat(addedId);
    setDisabledCards(newDisabledCards);
};

export const removeLastCardFromBoard = (board, setBoard, setDisabledCards) => {
    const removedCard = board[board.length - 2];
    setBoard((board) => board.slice(0, -1));
    if (removedCard) {
        updateDisabledCards(removedCard.id, setDisabledCards);
    } else {
        setDisabledCards([]);
    }
};

export const startPipeline = (board, navigateToNextPage) => {
    if (board.length === 0) {
        alert("Please add features to the pipeline before starting!");
        return;
    }
    // attiva la pipeline (drawer visibile)
    setActivePipeline(board);
    // avvia dal primo step
    navigateToNextPage(0, {});
};

export const navigateToNextPage = (index, params, board, navigate) => {
    if (index >= board.length) {
        alert("Pipeline completed!");
        clearActivePipeline();
        navigate('/dashboard');
        return;
    }

    // evidenzia lo step corrente
    updatePipelineIndex(index);

    const currentPage = board[index];
    const nextPageIndex = index + 1;

    navigate(currentPage.url, {
        state: {
            params,
            nextPageIndex,
            board,
            fromPipeline: true,      //  MARCATORE
        },
    });
};
